import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import LandingPage from './pages/LandingPage';
import { ProductsPage, ProductPage } from './pages/ProductPages';
import { ServicosPage, EstudioPage, ContactoPage } from './pages/SitePages';
import { ChangelogPage } from './pages/ChangelogPage';
import { BlogPage, BlogPost } from './pages/BlogPage';
import PlayPage from './pages/PlayPage';
import { PrivacyPage, RefundPage, TermsPage, CookiesPage } from './pages/StaticPages';
import { CartProvider, ApparelHome, ApparelProduct, ApparelAdmin, ApparelAccount } from './apparel/Apparel';
import { AuthProvider } from './context/AuthContext';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <CartProvider>
      <Routes>
        <Route path="/apparel"        element={<ApparelHome />} />
        <Route path="/apparel/admin"   element={<ApparelAdmin />} />
        <Route path="/apparel/account" element={<ApparelAccount />} />
        <Route path="/apparel/:slug"  element={<ApparelProduct />} />
        <Route path="/"               element={<LandingPage />} />
        <Route path="/produtos"       element={<ProductsPage />} />
        <Route path="/produtos/:slug" element={<ProductPage />} />
        <Route path="/servicos"       element={<ServicosPage />} />
        <Route path="/estudio"        element={<EstudioPage />} />
        <Route path="/changelog"      element={<ChangelogPage />} />
        <Route path="/blog"           element={<BlogPage />} />
        <Route path="/blog/:slug"     element={<BlogPost />} />
        <Route path="/contacto"       element={<ContactoPage />} />
        <Route path="/play"           element={<PlayPage />} />

        {/* Legal */}
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/refund"  element={<RefundPage />} />
        <Route path="/terms"   element={<TermsPage />} />
        <Route path="/cookies" element={<CookiesPage />} />

        {/* Old routes → new homes */}
        <Route path="/trabalho" element={<Navigate to="/produtos" replace />} />
        <Route path="/jogos"    element={<Navigate to="/estudio" replace />} />
        <Route path="/about"    element={<Navigate to="/estudio" replace />} />
        <Route path="/faq"      element={<Navigate to="/produtos" replace />} />
        <Route path="/contact"  element={<Navigate to="/contacto" replace />} />
        <Route path="/login"    element={<Navigate to="/" replace />} />
        <Route path="/register" element={<Navigate to="/" replace />} />
        <Route path="/forgot-password" element={<Navigate to="/" replace />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
